import AdminConceptGroupComponent from "../../Components/Admin/conceptGroup";

export default function AdminConceptGroupPage() {
	return <AdminConceptGroupComponent />;
}
